"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.longTermPower = void 0;
const longTermPower = exports.longTermPower = {
  EU_LONG_TERM_POWER_ANALYTICS: {
    en: {
      title: 'ICIS EU Long-Term Power',
      subtitle: 'An integrated view of rapidly evolving power markets'
    },
    zh: {
      title: 'ICIS欧盟远期电力',
      subtitle: '综合纵览快速发展的电力市场'
    }
  }
};